module.exports = __webpack_public_path__ + "assets/img/alert-triangle.93e42392.svg";